(function () {
    'use strict';

    angular
        .module('app')
        .controller('ChangeUserPasswordController', ChangeUserPasswordController);

    function ChangeUserPasswordController($scope, $stateParams, $state, $rootScope, PasswordService, AuthenticationService, FlashService) {
        var vm = this;
        vm.changePassword = changePassword;
        vm.isWebApiCallFailed = false;
        vm.error = "";
        //alert($rootScope.userId);

        vm.userData = { userName  : $rootScope.userName, CurrentPassword: "", NewPassword: "", ConfirmPassword: "" };


        function changePassword(isFormInvalid) {
            vm.isWebApiCallFailed = false;
            if (!isFormInvalid) {
                PasswordService.changeUserPassword(vm.userData).then(function (data) {
                    AuthenticationService.clearCredentials();
                    $rootScope.messageData = { code: "ChangePasswordSuccess", title: "Change Password Success" };
                    $state.go('displayMessage');
                }, function (error, status) {

                    vm.userData.CurrentPassword = "";
                    vm.userData.NewPassword = "";
                    vm.userData.ConfirmPassword = "";

                    vm.isWebApiCallFailed = true;
                    $scope.changepasswordform.$setPristine();
                    $scope.changepasswordform.$setUntouched();

                    var errors = [];
                    if (!error) {
                        errors.push('Server Error. Please contact your system administrator');
                    }
                    else {
                        for (var key in error.ModelState) {
                            for (var i = 0; i < error.ModelState[key].length; i++) {
                                errors.push(error.ModelState[key][i]);
                            }
                        }
                    }
                    vm.error = errors;
                });
            }
        }

        $scope.$watch('vm.userData', function (newObject, oldObject) {
            if (newObject.NewPassword != oldObject.NewPassword) {
                vm.passwordStrength = PasswordService.getStrength(newObject.NewPassword);
                vm.passwordProgressStyle = { width: vm.passwordStrength + '%' };

                if (vm.isPasswordWeak()) {
                    $scope.changepasswordform.password.$setValidity('strength', false);
                } else {
                    $scope.changepasswordform.password.$setValidity('strength', true);
                }
                //console.log(vm.passwordProgressStyle);
            }
        }, true);

        vm.isPasswordWeak = function () {

            return vm.passwordStrength < 40;
        }

        vm.isPasswordOk = function () {

            return vm.passwordStrength >= 40 && vm.passwordStrength <= 70;
        }

        vm.isPasswordStrong = function () {

            return vm.passwordStrength > 70;
        }
    }

})();